import React, { FunctionComponent } from "react";
import { Avatar, MenuItem, Stack, useTheme } from "@mui/material";
import styles from "./styles.module.scss";
import { useContextMenu } from "../../../hooks/contextMenu";
import { LayoutOptionsMenu } from "../LayoutOptionsMenu";

export const ShelfSelectItem: FunctionComponent<IShelfSelectItemProps> = ({
  name,
  index,
  onModify,
  onDelete,
  setIsSelectOpen,
  value,
  ...props
}) => {
  const theme = useTheme();
  const { menuProps, handleContextMenu, handleMenuClose } = useContextMenu();
  return (
    <MenuItem {...props} value={value} onContextMenu={handleContextMenu}>
      <Stack direction={"row"} spacing={2}>
        <div className={styles.badgeDiv}>
          <Avatar
            className={styles.badge}
            sx={{
              bgcolor: theme.palette.background.default,
              color: theme.palette.primary.main,
              fontSize: "14px",
              fontWeight: "bold"
            }}
          >
            {index}
          </Avatar>
        </div>
        <p className={styles.name}>{name}</p>
      </Stack>
      <LayoutOptionsMenu
        menuProps={menuProps}
        handleMenuClose={handleMenuClose}
        onModify={onModify}
        onDelete={onDelete}
        setIsSelectOpen={setIsSelectOpen}
      />
    </MenuItem>
  );
};

interface IShelfSelectItemProps {
  name: string;
  index: number;
  onModify: () => void;
  onDelete: () => void;
  setIsSelectOpen: (isSelectOpen: boolean) => void;
  value: string;
}
